import { EuiFlexGroup, EuiFlexItem } from "@elastic/eui";
import Button from "components/Buttons/Button";

interface Props {
  onApply: () => void;
  onCancel: () => void;
  isDisabled?: boolean;
  leftChildren?: any;
  isLimitError?: boolean | undefined;
}

const FDFilterDropdownFooter = ({
  onApply,
  onCancel,
  isDisabled = false,
  leftChildren = null,
  isLimitError,
}: Props) => {
  return (
    <div
      style={{
        backgroundColor: "var(--app-background)",
        borderBottomLeftRadius: 10,
        borderBottomRightRadius: 10,
      }}>
      {isLimitError && (
        <div
          style={{
            padding: "8px",
            color: "red",
            backgroundColor: "var(--app-background)",
            fontSize: "var(--fs12)",
          }}>
          Too many filters selected. Please reduce the number and try again.
        </div>
      )}
      <EuiFlexGroup
        gutterSize="m"
        justifyContent={leftChildren ? "spaceBetween" : "flexEnd"}
        style={{ padding: "5px" }}>
        {leftChildren && (
          <EuiFlexItem grow={false} style={{ paddingTop: "5px" }}>
            {leftChildren}
          </EuiFlexItem>
        )}
        <EuiFlexItem grow={false}>
          <EuiFlexGroup gutterSize="m" justifyContent="flexEnd" style={{ padding: "5px" }}>
            <EuiFlexItem grow={false}>
              <Button type="secondary" text="Cancel" onClick={onCancel} disabled={isDisabled} />
            </EuiFlexItem>
            <EuiFlexItem grow={false}>
              <Button type="primary" text="Apply" onClick={onApply} disabled={isDisabled} />
            </EuiFlexItem>
          </EuiFlexGroup>
        </EuiFlexItem>
      </EuiFlexGroup>
    </div>
  );
};
export default FDFilterDropdownFooter;
